import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  Paper,
} from "@mui/material";
import SeoMetaTags from "../components/SeoMetaTags";

/**
 * OurHistory Component
 *
 * Page component for the firm's history
 */
function OurHistory() {
  return (
    <>
      <SeoMetaTags
        title="Our History - Sentry Law Firm Journey | Sentry Law"
        description="Learn about the history and journey of Sentry Law. From our founding to our growth, discover our commitment to serving the Calgary community."
        slug="our-history"
      />
      <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }}>

      <Paper elevation={2} sx={{ p: { xs: 3, md: 4 }, borderRadius: 2 }}>
        <Grid container spacing={4}>
          {/* Left column (image on desktop, top on mobile) */}
          <Grid item xs={12} md={5}>
            <Box
              component="img"
              src="/images/law-office.jpg" // Replace with appropriate image
              alt="LawyerG Law Office"
              sx={{
                width: "100%",
                height: "auto",
                borderRadius: 1,
                boxShadow: 3,
                mb: { xs: 2, md: 0 },
              }}
            />
            <Box sx={{ mt: 3 }}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#003876" }}
              >
                LawyerG Law Firm
              </Typography>
              <Typography variant="body2">
                Located in the heart of Calgary, our office provides a welcoming
                environment for all our clients.
              </Typography>
            </Box>
          </Grid>

          {/* Right column (content) */}
          <Grid item xs={12} md={7}>
            <Typography
              variant="h4"
              component="h1"
              gutterBottom
              sx={{
                fontWeight: "bold",
                color: "#003876",
                borderBottom: "2px solid #d2232a",
                pb: 1,
                mb: 3,
              }}
            >
              OUR HISTORY
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                mb: 3,
                lineHeight: 1.7,
              }}
            >
              LawyerG's office is one of the fastest growing law firms in
              Calgary & area. We believe in providing our clients with the very
              best. no matter what legal matter they're seeing us for. The
              practice is based off providing a personalized legal approach to
              every client or potential client who walks through its doors.
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                mb: 4,
                lineHeight: 1.7,
              }}
            >
              Since our founding, we've been dedicated to serving the Calgary
              community with integrity and excellence. Our attorneys bring
              decades of combined experience across multiple practice areas,
              ensuring that we can meet virtually any legal need our clients may
              have.
            </Typography>

            <Button
              component={RouterLink}
              to="/calgary-law-office-location"
              variant="contained"
              size="large"
              sx={{
                backgroundColor: "#d2232a",
                "&:hover": {
                  backgroundColor: "#aa1c22",
                },
                fontWeight: "bold",
                px: 3,
                py: 1,
              }}
            >
              OUR HISTORY
            </Button>
          </Grid>
        </Grid>
      </Paper>
      </Container>
    </>
  );
}

export default OurHistory;
